import React from 'react';

import { MainModalController } from '@uikit/components/Modal';
import { OneInchColorBlack } from '@uikit/icons/OneInchColorBlack';
import { Settings } from '@uikit/icons/Settings';

import BaseInfoTooltip from '@shared/common/components/BaseInfoTooltip';

export interface SwapDetailsWidgetProps {
  providerFee: string;
  slippageModal: MainModalController;
  slippage: number;
}

const SwapDetailsWidget = ({ providerFee, slippageModal, slippage }: SwapDetailsWidgetProps) => {
  return (
    <ul className="w-full flex flex-col gap-4 rounded-2xl bg-primary-50 p-4 mt-4">
      <li className="flex max-sm:flex-col max-sm:items-start items-center justify-between gap-2 w-full text-neutral-400 text-[14px]">
        Provider
        <OneInchColorBlack className="h-[32px]" />
      </li>

      <li className="flex max-sm:flex-col max-sm:items-start items-center justify-between gap-2 w-full text-neutral-400 text-[14px]">
        Provider Fee
        <span>{providerFee}</span>
      </li>

      <li className="flex max-sm:flex-col max-sm:items-start items-center justify-between gap-2 w-full text-neutral-400 text-[14px]">
        <BaseInfoTooltip
          title="What is Slippage Tolerance?"
          content="Slippage Tolerance is the pricing difference between the price at the confirmation time and the actual price of the transaction users are willing to accept when swapping on AMMs. Slippage tolerance is set as a percentage of the total swap value."
        >
          Slippage
        </BaseInfoTooltip>

        <button
          className="button button-ghost gap-1 px-0 items-center font-normal"
          onClick={slippageModal.open}
        >
          {slippage}%
          <Settings className="icon-xs text-secondary" />
        </button>
      </li>
    </ul>
  );
};

export default SwapDetailsWidget;
